<template>
    <v-flex xs12 class="chapter">
        <v-layout row
                  wrap
                  justify-space-between>
            <v-layout column wrap>
                <v-flex xs12 class="chapter__middle">
                    <div v-if="displayNewsFeed" :class="['relative-position', 'chapter__middle--newsSpacing', routeConfigHideHeader && 'no-header-layout']">
                        <component :is="newsComponentType" v-bind="newsFeedProps"></component>
                    </div>
                    <div v-if="showBackToHomeFeedButton">
                        <return-to-activity-feed :title="communityCommonConstant.RETURN_TO_HOME_LINK">
                        </return-to-activity-feed>
                    </div>
                    <div v-else>
                        <add-post v-if="showAddPost"></add-post>
                      <v-flex v-if="isHome" class="home-page_follow_link">
                        {{communityCommonConstant.post.HOME_PAGE_Follow_LABEL}}
                        <a @click="openFavoritesPage()" data-qe-id="home-page_follow_link"><strong>{{communityCommonConstant.post.HOME_PAGE_Follow_People_LABEL}} </strong></a>
                      </v-flex>
                    </div>
                    <activity-feed :show-inappropriate-posts="false"></activity-feed>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-flex>
</template>

<script>
    import SponsorCard from '../ChapterPage/./SponsorCard/SponsorCard';
    import ActivityFeed from '../ChapterPage/./ActivityFeed/ActivityFeed';
    import AddPost from "../ChapterPage/AddPost/AddPost";
    import { routerNames } from "../appCommon.constants";
    import { communityCommonConstant } from "../ChapterPage/communityCommon.constant";
    import ReturnToActivityFeed from "../ChapterPage/ActivityFeed/ReturnToActivityFeed";
    import { storeMutation } from "../../store/storeMutations.constant.js";
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import AdminPage from '../ChapterPage/AdminPage/AdminPage';
    import FeatureEvent from '../ChapterPage/FeatureEvent/FeatureEvent';
    import { appConstant } from "../../app.constant";
    import NewsFeed from "../NewsFeed/NewsFeed";
    import { storeGetters } from "../../store/storeGetters.constant";
    import NewsFeedEditor from "@/components/NewsFeed/NewsFeedEditor";
    import { storeAction } from "@/store/storeActions.constant";
    import { trackPageLoadTime } from '../../common/utils/performance';

    export default {
        name: 'HomePage',
        components: {
            NewsFeedEditor,
            ReturnToActivityFeed,
            AddPost,
            ActivityFeed,
            SponsorCard,
            NewsFeed,
            AdminPage,
            FeatureEvent,
        },
        mounted() {
            this.$nextTick(() => {
                trackPageLoadTime('HomePage');
            });
        },
        created() {
            this.getNewsFeed();
        },
        methods: {
            ...mapActions({
                getNewsFeed: `newsFeed/${storeAction.getNewsFeed}`,
            }),
            ...mapMutations({
                setMemberDirectorySearchText: `memberDirectory/${storeMutation.setMemberDirectorySearchText}`,
                setMemberSelectedLetterFilter: `memberDirectory/${storeMutation.setMemberSelectedLetterFilter}`,
                updateMemberSelectedLetterFilter: `memberDirectory/${storeMutation.updateMemberSelectedLetterFilter}`,
            }),

            showQuickLinkDialog() {
                this.dialogState.dialogOpen = true;
                this.getFreshQuickLinks2();
                this.getCategoryLinks();
            },
          openFavoritesPage() {
            this.setMemberDirectorySearchText('');
            const filterFromStorage = sessionStorage.getItem(appConstant.storageKeys.connectionDirectoryStoredFilters);
            this.updateMemberSelectedLetterFilter(filterFromStorage);
            this.$router.push({
              path: '/memberConnections',
              filters: sessionStorage.getItem(appConstant.storageKeys.connectionDirectoryStoredFilters) || null,
            });
          },
            closeQuickLinkDialog() {
                this.dialogState.dialogOpen = false;
            },
            toggleNewsEditor() {
                this.displayNewsEditor = !this.displayNewsEditor;
            },

        },
        data: () => {
            return {
                dialogState: {
                    isVisible: false,
                    dialogOpen: false,
                },
                communityCommonConstant,
                displayNewsEditor: false,
            };
        },
        computed: {
            ...mapGetters({
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                newsFeed: `newsFeed/${storeGetters.newsFeed}`,
                systemMessages: `notification/${storeGetters.systemMessages}`,
                routeConfigHideHeader: `${[storeGetters.routeConfigHideHeader]}`,
                isTeamProductManager: `auth/${storeGetters.isTeamProductManager}`,
                isGroupSuperAdmin: `auth/${storeGetters.isGroupSuperAdmin}`,
            }),
            isHome() {
                return this.$route.name.toLowerCase() === routerNames.HOME.toLowerCase();
            },
            showBackToHomeFeedButton() {
                return this.$route.query && this.$route.query.postId;
            },
            newsFeedProps() {
                const { newsFeed, toggleNewsEditor } = this;
                return {
                    newsFeed,
                    toggleNewsEditor,
                };
            },
            newsComponentType() {
                return this.displayNewsEditor ? 'NewsFeedEditor' : 'NewsFeed';
            },
            displayNewsFeed() {
                return this.newsFeed && this.newsFeed.newsList && this.newsFeed.newsList.length;
            },

            hasSystemMessage() {
                return this.systemMessages.length > 0;
            },
            showAddPost() {
              return this.isTeamProductManager || this.isGroupSuperAdmin;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .chapter {
        &__left {
            min-height: 150px;
            background-color: $white;
            border: 1px solid $ypo-medium-gray;
            border-radius: 4px;
            text-align: center;
            font-weight: bold;
            margin-bottom: 15px;
            padding: 15px;
        }

        &__middle {
            min-height: 400px;

            &--newsSpacing {
                @include breakpoint(xs) {
                    margin-top: 65px;
                }
            }
        }

        &__right {
            min-height: 150px;
            background-color: $white;
            border: 1px solid $ypo-medium-gray;
            border-radius: 4px;
            text-align: center;
            font-weight: bold;
            margin-bottom: 15px;
            padding: 15px;
        }
    }

    .sponsor {
        font-size: 22px !important;
        font-weight: 400;
        color: $ypo-blue;
    }

    .line-spacing {
        margin-right: 15px;
        margin-left: 15px;
    }

    h3 {
        color: $ypo-blue;
        font-size: 22px;
        letter-spacing: -0.72px;
        line-height: 30px;
        font-weight: 400;
        text-align: left;
    }

    .aggregated-label {
        color: $ypo-gold;
        font-size: 12px;
        font-family: 'Raleway', sans-serif;
        font-weight: 600;
        position: relative;
        top: -10px;
        opacity: 0.9;
    }



    .home-page_follow_link {
      text-align: center;
      margin: -10px 0 10px 0;

      a {
        font-size: 14px;
        color: $ypo-gray-text;
      }

      strong {
        font-weight: 600;
        color: $ypo-cta;
      }
    }
</style>
